import React, { useEffect, useState } from 'react'
import { Box, Select, FormControl, Input, Stack, Text } from '@/components/lib'
import utils from '../../utils/utils'
import useStore from '../../store'

export default function TemperatureEditor ({ value, onChange }) {
  const { settings, changeSetting } = useStore()
  const measurement = settings?.temperatureMeasureType || 'metric'
  const [temperature, setTemperature] = useState()
  const [temperatureFahrenheit, setTemperatureFahrenheit] = useState()

  useEffect(() => {
    const val = value?.toString().replace(/^0.+/, '') || ''
    setTemperature(val)
    setTemperatureFahrenheit(utils.celsiusToFahrenheit(val))
  }, [value])

  const updateMetricTemperature = c => {
    setTemperature(c)
    if (c === '' || parseFloat(c)) {
      onChange(c)
      const f = utils.celsiusToFahrenheit(c)
      setTemperatureFahrenheit(f)
    }
  }

  const updateImperialTemperatire = f => {
    setTemperatureFahrenheit(f)
    if (f === '' || parseFloat(f)) {
      const c = utils.fahrenheitToCelsius(f)
      setTemperature(c)
      onChange(c)
    }
  }

  return (
    <Box>
      <Box>
        <Select
          w='200px' placeholder='Measurement type...' size='xs' mr={2} bg='bg.surface'
          value={measurement}
          onChange={e => changeSetting('temperatureMeasureType', e.target.value || 'metric')}
        >
          <option value='metric'>Metric (Celsius)</option>
          <option value='imperial'>Imperial (Fahrenheit)</option>
        </Select>
      </Box>

      <Box display={{ md: 'flex' }} mt={2}>
        {measurement === 'metric' &&
          <>
            <FormControl bg='bg.accent' rounded='md' p={2} w='150px' label='Temperature'>
              <Stack direction='row' alignItems='center'>
                <Input width='80px' bg='bg.surface' size='sm' value={temperature ?? ''} onChange={e => updateMetricTemperature(e.target.value.replace(/[^\d.-]/g, ''))} />
                <Text>°C</Text>
              </Stack>
            </FormControl>
          </>}

        {measurement === 'imperial' &&
          <>
            <FormControl bg='bg.accent' rounded='md' p={2} w='150px' label='Temperature'>
              <Stack direction='row' alignItems='center'>
                <Input width='80px' bg='bg.surface' size='sm' value={temperatureFahrenheit ?? ''} onChange={e => updateImperialTemperatire(e.target.value.replace(/[^\d.-]/g, ''))} />
                <Text>°F</Text>
              </Stack>
            </FormControl>
          </>}
      </Box>
    </Box>
  )
}
